<div class="language-dropdown" [class.open]="isOpen">
  <button class="lang-button" (click)="toggleDropdown()">
    {{ currentLang.toUpperCase() }}
    <svg width="10" height="6" viewBox="0 0 10 6" [class.rotate]="isOpen">
      <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M1 1l4 4 4-4"/>
    </svg>
  </button>
  
  <div class="dropdown-menu" *ngIf="isOpen">
    <div 
      *ngFor="let lang of getOtherLanguages()" 
      class="dropdown-item"
      (click)="changeLang(lang)"
    >
      {{ lang.toUpperCase() }}
    </div>
  </div>
</div>